import React from "react";
import CheckoutPageComponent from "../../components/CheckoutComponent/CheckoutComponent";
import CheckoutPage from "./CheckoutAll";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_PAYMENT_LINK_BY_SHORTCODE } from "../../graphql/queries/paymentlink";
import { environment } from "../../env";
import {
  checkoutProduct,
  selectedProduct,
  brandSettings as $brandSettings,
} from "../../store/nanostore";
import { useStore } from "@nanostores/react";
import { Overlay, LoadingSpinner } from "../../pages/AddUserPage/AddUser";
import ErrorComponent from "../../components/NotFound";
import useBrandSettings from "../../utils/getBrandSettingsByOrganizationId";

const Checkout = () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery(GET_PAYMENT_LINK_BY_SHORTCODE, {
    variables: { ...environment.paymentLinkService, id: id },
  });
  const organizationId =
    data?.paymentLinkByShortcode?.paymentLink?.organizationId;
  const {
    brandSettings,
    loading: brandLoading,
    error: brandError,
  } = useBrandSettings(organizationId);

  React.useEffect(() => {
    if (!loading && data) {
      checkoutProduct.set(data?.paymentLinkByShortcode);
      selectedProduct.set(
        data?.paymentLinkByShortcode?.products?.map(
          ({ productId, quantity, ProductInstance, paymentLinkId }: any) => ({
            ProductInstance,
            id: productId,
            productId,
            paymentLinkId,
            quantity,
            price: ProductInstance.price,
          })
        )
      );
    }
  }, [loading, data]);

  React.useEffect(() => {
    if (!brandLoading && brandSettings) {
      $brandSettings.set(brandSettings);
    }
  }, [brandSettings, brandLoading]);

  return loading || brandLoading ? (
    <Overlay>
      <LoadingSpinner />
    </Overlay>
  ) : !error || !brandError ? (
    <Wrapper>
      <CheckoutPageComponent />
      <CheckoutPage />
    </Wrapper>
  ) : (
    <ErrorComponent />
  );
};

export default Checkout;

export const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  margin-left: auto;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;
